<template>
  <div class="search-page">
    <page-header />
    <page-main />
  </div>
</template>
<script>
import PageHeader from './views/page-header/page-header.vue'
import PageMain from './views/page-main/page-main.vue'
export default {
  name: 'App',
  components: { PageHeader, PageMain },
  mounted() {
    document.title = '中国检验认证集团浙江有限公司'
  }
}
</script>
